import { createActionGroup, props } from '@ngrx/store';
import { ISlideshow } from '../../pages/slideshows/slideshows.interface';

export const slideshowContentActions = createActionGroup({
  events: {
    fetchError: props<{ exceptionSource: 'fetchSlideshowContents' }>(),
    fetchSlideshowContents: props<{ slideshowId: number }>(),
    fetchSlideshowContentsCompleted: props<{ slideshow: ISlideshow }>(),
  },
  source: 'slideshowContent',
});
